import selfDeletionSlice from "./containers/AccountDeletionLockPage/redux/deletion-lock.slice.ts"
import accountDeletionSlice from "./containers/AccountDeletionRequestsPage/redux/account-deletion.slice.ts"
import albumSlice from "./containers/Album/redux/album.slice.ts"
import calendarSlice from "./containers/Calendar/redux/calendar.slice.ts"
import contractsSlice from "./containers/Contracts/redux/contracts.slice.ts"
import customerDetailSlice from "./containers/CustomersPage/CustomerDetailPage/redux/customer-detail.slice.ts"
import customersSlice from "./containers/CustomersPage/redux/customers.slice.ts"
import dashboardSlice from "./containers/DashboardPage/redux/dashboard.slice"
import portfolioSlice from "./containers/DashboardPage/redux/portfolio.slice.ts"
import widgetsSlice from "./containers/DashboardPage/redux/widgets.slice.ts"
import documentTemplatesSlice from "./containers/DocumentTemplates/redux/document-templates.slice.ts"
import leadSlice from "./containers/Lead/redux/lead.slice.ts"
import leadsSlice from "./containers/Leads/redux/leads.slice.ts"
import authSlice from "./containers/LoginPage/redux/auth.slice.ts"
import notificationSlice from "./containers/Notifications/redux/notification.slice.ts"
import projectSlice from "./containers/Project/redux/project.slice.ts"
import projectsSlice from "./containers/Projects/redux/projects.slice"
import proposalsSlice from "./containers/Proposals/redux/proposals.slice.ts"
import invoicesSlice from "./containers/Invoices/redux/invoices.slice.ts"
import reportCanvasSlice from "./containers/ReportsPage/redux/reportCanvas.slice.ts"
import reportsSlice from "./containers/ReportsPage/redux/reports.slice.ts"
import settingsSlice from "./containers/Settings/redux/settings.slice.ts"
import permissionsSlice from "./containers/SettingsPermissions/redux/permissions.slice.ts"
import subcontractorsSlice from "./containers/SubcontractorsPage/redux/subcontractors.slice.ts"
import suppliersSlice from "./containers/SuppliersPage/redux/suppliers.slice.ts"
import teamMembersSlice from "./containers/TeamManagementPage/redux/team-members.slice.ts"
import templatesSlice from "./containers/Templates/redux/templates.slice.ts"
import uiPreferencesSlice from "./containers/User/redux/ui-preferences.slice.ts"
import errorsSlice from "./redux/errors.slice"
import navSlice from "./redux/nav/nav.slice.ts"
import notificationCountsSlice from "./redux/notificationCounts/notification-counts.slice.ts"

// import projectKanbanSlice from "./Containers/Project/ProjectKanbanPage/redux/projectKanban.slice"
// import projectManagementSlice from "./Containers/Project/project-management-pages/redux/projectManagement.slice"
// import projectDocumentsSlice from "./Containers/Project/project-pages/ProjectDocumentsPage/redux/projectDocuments.slice"
// import projectSubcontractorsSlice from "./Containers/Project/project-pages/ProjectSubcontractorsPage/redux/projectSubcontractors.slice"

export const rootReducer = {
  [authSlice.name]: authSlice.reducer,
  [errorsSlice.name]: errorsSlice.reducer,
  [navSlice.name]: navSlice.reducer,
  [leadsSlice.name]: leadsSlice.reducer,
  [leadSlice.name]: leadSlice.reducer,
  [calendarSlice.name]: calendarSlice.reducer,
  [customersSlice.name]: customersSlice.reducer,
  [customerDetailSlice.name]: customerDetailSlice.reducer,
  [subcontractorsSlice.name]: subcontractorsSlice.reducer,
  [suppliersSlice.name]: suppliersSlice.reducer,
  [teamMembersSlice.name]: teamMembersSlice.reducer,
  [accountDeletionSlice.name]: accountDeletionSlice.reducer,
  [selfDeletionSlice.name]: selfDeletionSlice.reducer,
  [settingsSlice.name]: settingsSlice.reducer,
  [dashboardSlice.name]: dashboardSlice.reducer,
  [portfolioSlice.name]: portfolioSlice.reducer,
  [widgetsSlice.name]: widgetsSlice.reducer,
  [templatesSlice.name]: templatesSlice.reducer,
  [contractsSlice.name]: contractsSlice.reducer,
  [proposalsSlice.name]: proposalsSlice.reducer,
  [projectSlice.name]: projectSlice.reducer,
  [projectsSlice.name]: projectsSlice.reducer,
  [albumSlice.name]: albumSlice.reducer,
  [notificationSlice.name]: notificationSlice.reducer,
  [notificationCountsSlice.name]: notificationCountsSlice.reducer,
  [documentTemplatesSlice.name]: documentTemplatesSlice.reducer,
  [permissionsSlice.name]: permissionsSlice.reducer,
  [uiPreferencesSlice.name]: uiPreferencesSlice.reducer,
  [reportsSlice.name]: reportsSlice.reducer,
  [reportCanvasSlice.name]: reportCanvasSlice.reducer,
  [invoicesSlice.name]: invoicesSlice.reducer

  // [projectDocumentsSlice.name]: projectDocumentsSlice.reducer,
  // [projectSubcontractorsSlice.name]: projectSubcontractorsSlice.reducer,
  // [projectManagementSlice.name]: projectManagementSlice.reducer,
  // [projectKanbanSlice.name]: projectKanbanSlice.reducer,
}
